import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './routes/Home';
import { Indication } from './routes/Indication';
import { Result } from './routes/Result';
import { Property } from './routes/Property';
import { PropertyForm } from './routes/PropertyForm';
import { PropertyResult } from './routes/PropertyResult';
import { PropertyContactBroker } from './routes/PropertyContactBroker';
import { Showcase } from './routes/Showcase';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Eyebrow } from './components/Eyebrow';
import { Button } from './components/Button';

function NotFound() {
  return (
    <>
      <Navbar />
      <main className="container-site py-24" style={{ minHeight: '60vh' }}>
        <div className="flex flex-col gap-6 max-w-2xl">
          <Eyebrow>404 · NOT_FOUND</Eyebrow>
          <h1 className="font-display font-medium tracking-[-0.02em] text-[clamp(32px,5vw,56px)] leading-[1.05]">
            We can't find that page.
          </h1>
          <p className="text-ink-muted">
            The link may be outdated. Head back home, or get an indication in minutes.
          </p>
          <div className="flex flex-wrap gap-3 pt-2">
            <Button as="link" to="/" variant="secondary">
              Return home
            </Button>
            <Button as="link" to="/indication" variant="primary">
              Builders Risk Indication
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/indication" element={<Indication />} />
        <Route path="/indication/result/:id" element={<Result />} />
        <Route path="/property" element={<Property />} />
        <Route path="/property/form" element={<PropertyForm />} />
        <Route path="/property/contact-broker" element={<PropertyContactBroker />} />
        <Route path="/property/result/:id" element={<PropertyResult />} />
        <Route path="/_ui" element={<Showcase />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
